export default __webpack_public_path__ + "static/media/6.b8af150b.webp";